import Budget from './Budget';

export default class EmployeeWithBudgets {
    uuid: string;
    lastName: string;
    firstName: string;
    workPercentage?: number; // e.g., 100 for full-time, 80 for 80%, 60 for 60%
    budgets: Budget[];

    static calculateBudgetCostForEmployee(employee: EmployeeWithBudgets, selectedDate: Date, daysPerMonth: number, budget?: Budget): number {
        let total = 0;

        if (budget) {
            total = Budget.calculateBudgetCost(budget, selectedDate, daysPerMonth, total);
        } else {
            employee.budgets.forEach((budget) => {
                total = Budget.calculateBudgetCost(budget, selectedDate, daysPerMonth, total);
            });
        }
        return total;
    }

    static calculateActualCostForEmployee(employeeWithBudgets: EmployeeWithBudgets, selectedDate: Date, daysPerMonth: number, budget?: Budget): number {
        let total = 0;
        if (budget) {
            total = Budget.calculateActualCost(budget, selectedDate, daysPerMonth, total);
        } else {
            employeeWithBudgets.budgets.forEach((budget) => {
                total = Budget.calculateActualCost(budget, selectedDate, daysPerMonth, total);
            });
        }
        return total;
    }
}
